import initialState from '../../../store/initialState';
import * as types from '../services/commonActionType';

const commonReducer = (state = initialState.common, action) => {

    switch (action.type) {

        case types.EXPORT_TO_CSV_REQUEST:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : true,
                lastExportRequestId: action.payload?.requestId || null,
                lastExportStatus: 'in_progress',
            };
        case types.EXPORT_TO_CSV_SUCCESS:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : false,
                lastExportRequestId: action.payload?.requestId || state.lastExportRequestId || null,
                lastExportStatus: 'success',
                lastExportCompletedAt: Date.now(),
            };
        case types.EXPORT_TO_CSV_FAILURE:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : false,
                lastExportRequestId: action.payload?.requestId || state.lastExportRequestId || null,
                lastExportStatus: 'failure',
                lastExportCompletedAt: Date.now(),
            };

        case types.DASHBOARD_DETAILS_REQUEST:
            return { ...state, isLoadingDashboard: true, };
        case types.DASHBOARD_DETAILS_SUCCESS:
            return {
                ...state,
                isLoadingDashboard: false,
                dashboardDetails: action.payload?.dashboardDetails,
                providerRequestDailyCounts: action.payload?.providerRequestDailyCounts || [],
                // first day of the initial load (newest first) = today in the user's timezone
                providerRequestTodayDate: action.payload?.providerRequestDailyCounts?.[0]?.RequestDate || null,
            };
        case types.DASHBOARD_DETAILS_FAILURE:
            return { ...state, isLoadingDashboard: false, dashboardDetails: [], providerRequestDailyCounts: [] };

        case types.PROVIDER_REQUEST_DAILY_COUNTS_REQUEST:
            return { ...state, isLoadingProviderRequestDaily: true };
        case types.PROVIDER_REQUEST_DAILY_COUNTS_SUCCESS:
            return { ...state, isLoadingProviderRequestDaily: false, providerRequestDailyCounts: action.payload || [] };
        case types.PROVIDER_REQUEST_DAILY_COUNTS_FAILURE:
            return { ...state, isLoadingProviderRequestDaily: false, providerRequestDailyCounts: [] };

        case types.QGENDA_TASKS_SCHEDULES_REQUEST:
            return { ...state, isLoadingDashboard: true, };
        case types.QGENDA_TASKS_SCHEDULES_SUCCESS:
            return { ...state, isLoadingDashboard: false };
        case types.QGENDA_TASKS_SCHEDULES_FAILURE:
            return { ...state, isLoadingDashboard: false };

        case types.SET_ALLOWED_MENUS:
            return { ...state, allowedMenus: action.payload?.lstAllowedMenus || [] };

        case types.UPDATE_COMMON_REDUCER:
            return { ...state, ...action.payload };

        case types.TENANT_CONFIGURATION_REQUEST:
            return { ...state, isTenantConfigurationLoading: true, tenantConfiguration: null, tenantConfigurationError: null };
        case types.TENANT_CONFIGURATION_SUCCESS:
            return { ...state, isTenantConfigurationLoading: false, tenantConfiguration: action.payload, tenantConfigurationError: null };
        case types.TENANT_CONFIGURATION_FAILURE:
            return { ...state, isTenantConfigurationLoading: false, tenantConfiguration: null, tenantConfigurationError: action.payload };

        case types.ASSIGNED_SITES_COUNT_SUCCESS:
            return { ...state, assignedSitesCount: action.payload || 0 };
        case types.ASSIGNED_SITES_COUNT_FAILURE:
            return { ...state, assignedSitesCount: 0 };

        case types.UNASSIGNED_SITES_COUNT_SUCCESS:
            return { ...state, unassignedSitesCount: action.payload || 0 };
        case types.UNASSIGNED_SITES_COUNT_FAILURE:
            return { ...state, unassignedSitesCount: 0 };

        case types.ASSIGNED_ROLES_WITH_PRACTICES_SUCCESS:
            return { ...state, assignedRolesWithPractices: action.payload?.assignedRolesWithPracticesList || [] };
        case types.ASSIGNED_ROLES_WITH_PRACTICES_FAILURE:
            return { ...state, assignedRolesWithPractices: [] };

        case types.GET_TIMEZONE_SUCCESS:
            return { ...state, dynamicTimezone: action.payload?.TimeZoneCode || null };
        case types.GET_TIMEZONE_FAILURE:
            return { ...state, dynamicTimezone: null };

        case types.DEFAULT_WORKLISTS_REQUEST:
            return { ...state, defaultWorklists: { ...state.defaultWorklists, isLoading: true } };
        case types.DEFAULT_WORKLISTS_SUCCESS:
            return {
                ...state,
                defaultWorklists: {
                    items: action.payload?.items || [],
                    isProvider: !!action.payload?.isProvider,
                    userId: action.payload?.userId ?? null,
                    isLoaded: true,
                    isLoading: false,
                },
            };
        case types.DEFAULT_WORKLISTS_FAILURE:
            // Treat a failure as "no defaults" so screens fall back to their current behaviour.
            return {
                ...state,
                defaultWorklists: { items: [], isProvider: false, userId: action.payload?.userId ?? null, isLoaded: true, isLoading: false },
            };

        default:
            return state;
    }
};

export default commonReducer;